import Storage from 'views/assets/scripts/services/storage/storage'

type VariantPositionData = {
  path: string
  top: number
}

export class PdpVariantsPosition {
  static SELECTOR_HEADER = '#h_ProductVariants .m-ProductVariants__header'
  static SELECTOR_VARIANT = '.m-ProductVariant__link'
  static MOBILE_HEADER_HEIGHT = 56
  static KEY_STORAGE = 'variant-position'

  constructor(private container: HTMLElement, private storage: Storage) {}

  init() {
    if (this.shouldScroll()) {
      this.scroll()
    }

    this.clear()
    this.bindEventHandlers()
  }

  shouldScroll(): boolean {
    const currentPath = new URL(window.location.href).pathname
    const savedPath = this.getPositionData().path

    return Boolean(savedPath) && savedPath === currentPath
  }

  scroll() {
    const { top } = this.getPositionData()

    if (top) {
      window.scrollTo({ top })
    }
  }

  clear() {
    this.storage.remove(PdpVariantsPosition.KEY_STORAGE)
  }

  bindEventHandlers() {
    this.container
      .querySelectorAll(PdpVariantsPosition.SELECTOR_VARIANT)
      .forEach(elem => {
        elem.addEventListener('click', this.handleVariantClick)
      })
  }

  getPositionData(): VariantPositionData {
    return this.storage.get(PdpVariantsPosition.KEY_STORAGE) || {}
  }

  setPositionData(data: VariantPositionData) {
    this.storage.set(PdpVariantsPosition.KEY_STORAGE, data)
  }

  getTopCoord(): number {
    const box = document.querySelector(PdpVariantsPosition.SELECTOR_HEADER)

    const bodyTop = document.body.getBoundingClientRect().top
    const boxTop = box?.getBoundingClientRect().top
    const top = boxTop
      ? boxTop - bodyTop - PdpVariantsPosition.MOBILE_HEADER_HEIGHT
      : null

    return top && top > 0 ? top : 0
  }

  handleVariantClick = (event: Event) => {
    const target = (<HTMLAnchorElement>event.target).closest('a')

    if (target?.href) {
      const currentPath = new URL(target.href).pathname

      this.setPositionData({
        path: currentPath,
        top: this.getTopCoord(),
      })
    }
  }
}
